<template>
  <v-dialog
    v-model="dialog"
    persistent
    content-class="rounded-10"
    max-width="780"
  >
    <v-card class="rounded-10">
      <v-card-title class="title-font mb-1" style="font-weight: 600">
        UNKNOWN IDENTITY
      </v-card-title>

      <v-card-text class="text-body-1 black--text">
        <v-row align="center">
          <v-col cols="3">
            <v-icon color="primary" size="128">mdi-help-circle</v-icon>
          </v-col>
          <v-col>
            <v-row>
              <v-col>
                The email address or phone number you've used to log in is not
                associated to a Nexus IOS or Osteon account.
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                Log out and try with a different identity, or contact customer
                service for further assistance.
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn class="btn-primary" @click="logOut"> Log Out </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "UnauthorisedClient",

  props: ["value"],

  computed: {
    dialog: {
      get() {
        return this.value
      },

      set(value) {
        this.$emit("input", value)
      }
    }
  },

  methods: {
    logOut() {
      window.location = `/oauth2/logout/`
    }
  }
}
</script>
